import type { DriveStep } from 'driver.js';

export const staffReceivingTourId = 'staff:receiving';

export const staffReceivingSteps: DriveStep[] = [
  {
    element: '[data-tour="staff:receiving-upload"]',
    popover: {
      title: 'Загрузка поставки',
      description:
        'Зона загрузки файлов. Перетащите XLSX-файл с данными поставки и PDF-накладную сюда. Система автоматически распарсит и создаст заказы.',
    },
  },
  {
    element: '[data-tour="staff:receiving-list"]',
    popover: {
      title: 'Список доставок',
      description:
        'Список доставок. После загрузки здесь появятся все поставки. Вы можете принять товар целиком или проверить каждую позицию отдельно.',
    },
  },
  {
    element: '[data-tour="staff:receiving-status"]',
    popover: {
      title: 'Статус приёмки',
      description:
        'Статус каждой поставки: новая, в процессе проверки, принята или с расхождениями. Следите за прогрессом приёмки.',
    },
  },
  {
    element: '[data-tour="staff:help-btn"]',
    popover: {
      title: 'Помощь',
      description: 'Напоминаем: кнопка помощи всегда здесь.',
    },
  },
];
